import styled, { css } from "styled-components";
import { Form } from "formik";
import { Form as FormBoot, Modal } from "react-bootstrap";

export const SelectTypeValidation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`;

export const FormRadioContent = styled.div`
  box-shadow: 0px 0px 10px -4px rgb(0 0 0 / 75%);
  display: flex;
`;

export const FormRadio = styled(FormBoot.Check)`
  padding: 0;

  .form-check-input {
    position: absolute;
    z-index: 10;
    opacity: 0;
  }

  .form-check-label {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    line-height: normal;
    border-bottom: 0 solid #00ff00;
    text-align: center;
    background: #000fff;
    color: #fff;
    font-weight: bold;
    margin: 0;
    user-select: none;

    &::before,
    &::after {
      content: none;
    }
  }

  ${({ isSelect }) =>
    isSelect &&
    css`
      .form-check-label {
        border-width: 2px;
      }
    `}
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  :nth-child(2) {
    button {
      margin-top: 20px;
    }
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ContentToken = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  border-top: 1px dashed #d8d8d8;

  #content-buttons {
    flex-direction: column;
    gap: 15px;

    > button {
      width: 100%;
    }
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    width: 40%;
  }
`;

export const TextLabel = styled.span`
  color: #0b24fb;
`;

export const TextTimer = styled.p`
  text-align: center;

  a {
    color: #0000ff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 450px;
    width: 100%;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 450px !important;
    place-content: center;
  }
`;

export const ModalContainer = styled.div`
  padding: 25px;
  width: 100%;
`;

export const ModalHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  button {
    width: 100%;
    max-width: 160px;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 18px;
  font-family: "Mangueira Bold";
`;

export const Paragraph = styled.p`
  margin: none;
  padding: none;
  text-align: left;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.gray};
`;
